/*!
 * Copyright © 2020-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EApiErrorCodes {
  MalformedRequest = 400,
  VerificationCodeInvalid = 403,
  SessionTimeout = 408,
  ServerError = 500,
}
